import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {StyledExpensesPage} from './StyledExpensesPage';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import ExpensesTabs from '../../components/pages/ExpensesPage/ExpensesTabs';
import InvoiceForward from '../../components/pages/InvoicesPage/InvoiceForward/InvoiceForward';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader/BalancePageHeader';
import PageDocumentDetails from '../../components/PageDocumentDetails/PageDocumentDetails';
import {useIsEmployeeLoaded} from '../../hooks';

const ExpensesPage = ({isAdmin}) => {
  const [t] = useTranslation('main');

  const title = t('pageTitles.expensesList');

  const isEmployeeLoaded = useIsEmployeeLoaded();

  return (
    <StyledExpensesPage>
      <PageDocumentDetails title={title} />
      <BalancePageHeader breadcrumbs={[{ title }]} />
      {(isEmployeeLoaded && !isAdmin) && <InvoiceForward />}
      <DashboardPageTransition>
        <ExpensesTabs />
      </DashboardPageTransition>
    </StyledExpensesPage>
  );
}

const mapStateToProps = state => {
  const isAdmin = state.user.isAdmin;
  return {
    isAdmin,
  }
}

export default connect(mapStateToProps, null)(ExpensesPage);
